export default __webpack_public_path__ + "static/air-beta-product-guis-043168196e1f3f15415767d629a4fc34.png";